<app-ranged-integer [value]="year"
                    (valueChanged)="yearChanged($event)"
                    [disabled]="!selectableYear"
                    [min]="minYear"
                    [max]="maxYear"></app-ranged-integer>
<!-- 
<div class="row">
  <div class="col-3">
    <button class="btn btn-primary"
            [disabled]="atMinYear"
            (click)="moveYear(-1)">
      <i class="fa fa-minus"></i>
    </button>
  </div>
  <div class="col-6">
    <h4>{{year}}</h4>
  </div>
  <div class="col-3">
    <button class="btn btn-primary" 
            [disabled]="atMaxYear"
            (click)="moveYear(1)">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div> -->

<div class="row g-1">
  <div *ngFor="let mth of months" class="col-xs-4 col-md-6 col-lg-4">
    <button class="btn w-100"
            [disabled]="monthDisabled[mth]"
            [ngClass]="monthClasses[mth]"
            [ngbTooltip]="monthsBefore?'Click to set as last month. Shift click to set as first month.':null"
            (click)="monthSelected(mth,$event)">{{mth}}</button>
  </div>
</div>
